// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"54ba9786","266":"76a486bf","299":"6433e416","364":"9c1dc8d9","624":"6d20b3dd","656":"d51c19f0","813":"f4c4f926","954":"ef812c17","974":"72194a1b"}[chunkId] + ".chunk.js";
};